import React from 'react';
import Header from './Header';
import Footer from './Footer';

const GlobalPresence = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
        </style>
        <!-- Document Wrapper -->
        <div id="wrapper">
            <!-- Content -->
            <section id="content">
                <div class="content-wrap py-0">
                    <!-- Hero Section -->
                    <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                        <div class="container mt-lg-6">
                            <div class="row justify-content-between align-items-center py-lg-6 py-5">
                                <div class="col-lg-6 mb-4 mb-lg-0">
                                    <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                                    <h2 class="display-3 fw-bold color all-ts">Exporting Nutraceuticals Worldwide</h2>
                                    <p class="lead">Delivering Health Globally with Trust, Compliance & Quality</p>
                                    <p>At Rexroth Nutriscience pvt. ltd., we proudly export a wide range of pharmaceutical-grade nutraceuticals to clients across the globe. Backed by state-of-the-art manufacturing, international regulatory certifications, and a reputation for quality, we are a trusted name in the global nutraceutical trade.</p>
                                </div>
                                <div class="col-lg-5">
                                    <img src="images/global.jpg" alt="Global Presence" class="rounded-6 w-100">
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- Why Choose Us Section -->
                    <div class="section my-0 bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Why Choose Rexroth as Your Nutraceutical Export Partner?</h2>
                                </div>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/certified.jpg" alt="Certified Manufacturing" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Certified Manufacturing</h4>
                                            <p class="mb-0">GMP, ISO 22000, FSSAI, and WHO-GMP Certified Manufacturing Units</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/compliance.png" alt="Regulatory Compliance" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Regulatory Compliance</h4>
                                            <p class="mb-0">100% Regulatory Compliant Products for USA, EU, Asia, MENA, Africa</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/custom.jpg" alt="Custom Solutions" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Custom Solutions</h4>
                                            <p class="mb-0">Custom Formulations for different markets & languages</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Global Reach Section -->
                    <div class="section bg-color dark my-0">
                        <div class="container py-lg-5">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 text-white mb-3">Our Global Export Reach</h2>
                                    <p class="text-white-50">We export to over 30+ countries, including:</p>
                                </div>
                            </div>
                            <div class="row g-4 justify-content-center">
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/mm.png" alt="Myanmar Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Myanmar</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/ng.png" alt="Nigeria Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Nigeria</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/ke.png" alt="Kenya Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Kenya</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/vn.png" alt="Vietnam Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Vietnam</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/za.png" alt="South Africa Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">South Africa</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/bd.png" alt="Bangladesh Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Bangladesh</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/np.png" alt="Nepal Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Nepal</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/lk.png" alt="Sri Lanka Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Sri Lanka</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/au.png" alt="Australia Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Australia</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body text-center p-4">
                                            <img src="https://flagcdn.com/w160/mz.png" alt="Mozambique Flag" class="mb-3" style="height: 40px; width: auto;">
                                            <h4 class="mb-0 text-dark">Mozambique</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Products Section -->
                    <div class="section my-0 bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Products We Export</h2>
                                    <p>We offer over 100+ formulations, including:</p>
                                </div>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/vitamins.webp" alt="Multivitamins & Minerals" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Multivitamins & Minerals</h4>
                                            <p class="mb-0">Comprehensive nutritional support in tablet and capsule forms</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/herbal.webp" alt="Herbal Capsules & Extracts" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Herbal Capsules & Extracts</h4>
                                            <p class="mb-0">Premium quality herbal formulations for natural wellness</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/beverages.webp" alt="Functional Beverages" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Functional Beverages</h4>
                                            <p class="mb-0">Health-enhancing drink formulations for daily wellness</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/effervescent.webp" alt="Effervescent Tablets" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Effervescent Tablets</h4>
                                            <p class="mb-0">Fast-dissolving tablets for quick nutrient absorption</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/fitness-powder.jpeg" alt="Probiotic & Digestive Health" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Probiotic & Digestive Health</h4>
                                            <p class="mb-0">Gut health supplements for optimal digestion</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/protein.jpeg" alt="Omega-3 & Joint Support" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Omega-3 & Joint Support</h4>
                                            <p class="mb-0">Essential fatty acids and collagen formulas for joint health</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Packaging & Labeling Section -->
                    <div class="section my-0 bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Packaging & Labeling for Export</h2>
                                    <p>Comprehensive packaging solutions tailored for global markets</p>
                                </div>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-3">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/packaging.jpg" alt="Private Labeling" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Private Labeling</h4>
                                            <p class="mb-0">Custom branding and white labeling solutions for your products</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/multilingual.png" alt="Multilingual Labels" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Multilingual Labels</h4>
                                            <p class="mb-0">Labels in English, Arabic, French, and other languages</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/qr-code.png" alt="QR Code Traceability" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">QR Code Traceability</h4>
                                            <p class="mb-0">Complete batch information and product tracking</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/eco-friendly.jpeg" alt="Eco-Friendly Packaging" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Eco-Friendly Packaging</h4>
                                            <p class="mb-0">Sustainable and tamper-proof packaging options</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Export Documentation Section -->
                    <div class="section bg-color dark my-0">
                        <div class="container py-lg-5">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 text-white mb-3">Export Documentation Support</h2>
                                    <p class="text-white-50">Comprehensive documentation services for seamless global trade</p>
                                </div>
                            </div>
                            <div class="row g-4 justify-content-center">
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/certificate-of-origin.jpeg" alt="Certificate of Origin" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3 text-dark">Certificate of Origin</h4>
                                            <p class="mb-0">Official documentation verifying product origin and compliance</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/documents.jpeg" alt="Health Certificates" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3 text-dark">Health Certificates</h4>
                                            <p class="mb-0">Required health and safety documentation for international trade</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/compliance.png" alt="Free Sale Certificates" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3 text-dark">Free Sale Certificates</h4>
                                            <p class="mb-0">Certification for products legally sold in the country of origin</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/commercial.jpeg" alt="Commercial Documentation" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3 text-dark">Commercial Documentation</h4>
                                            <p class="mb-0">Invoices and packing lists for international shipments</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/lab-test.jpg" alt="Lab Testing Reports" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3 text-dark">Lab Testing Reports</h4>
                                            <p class="mb-0">Third-party verification of product quality and safety</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/custom-clearance.jpg" alt="Custom Clearance Support" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3 text-dark">Custom Clearance Support</h4>
                                            <p class="mb-0">Expert assistance with customs documentation and procedures</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Regulatory Compliance Section -->
                    <div class="section my-0 bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Regulatory & Legal Compliance</h2>
                                    <p>Meeting global standards and certifications for international markets</p>
                                </div>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/compliance.png" alt="Global Regulatory Compliance" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Global Regulatory Compliance</h4>
                                            <p class="mb-0">Global Regulatory Compliance</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/dossier.png" alt="Complete Dossier Support" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Complete Dossier Support</h4>
                                            <p class="mb-0">Product COA, MOA, MSDS, and comprehensive documentation</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <img src="images/vegan.png" alt="Special Certifications" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
                                            <h4 class="mb-3">Special Certifications</h4>
                                            <p class="mb-0">Halal, Vegan, and Gluten-Free options available</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Partner With Us Section -->
                    <div class="section bg-color dark my-0">
                        <div class="container py-lg-5">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 text-white mb-3">Partner With Us</h2>
                                    <p class="text-white-50">Join our global network of trusted partners</p>
                                </div>
                            </div>
                            <div class="row g-4 justify-content-center">
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4 text-center">
                                            <h4 class="mb-3 text-dark">Distributor</h4>
                                            <p class="mb-0">Expand your product portfolio with our premium nutraceuticals</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4 text-center">
                                            <h4 class="mb-3 text-dark">Wholesaler</h4>
                                            <p class="mb-0">Access competitive pricing and bulk order benefits</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4 text-center">
                                            <h4 class="mb-3 text-dark">Private Label Brand</h4>
                                            <p class="mb-0">Create your own branded products with our white-label solutions</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4 text-center">
                                            <h4 class="mb-3 text-dark">Health Retail Chain</h4>
                                            <p class="mb-0">Stock your shelves with quality-assured supplements</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4 text-center">
                                            <h4 class="mb-3 text-dark">B2B Healthcare Company</h4>
                                            <p class="mb-0">Enhance your healthcare offerings with our nutraceutical range</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- FAQ Section -->
                    <div class="section my-0 bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Frequently Asked Questions (FAQs)</h2>
                                    <p>Common questions about our export operations</p>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-lg-10">
                                    <div class="accordion" id="faqAccordion">
                                        <div class="accordion-item border-0 mb-3">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
                                                    Does Rexroth Nutriscience pvt. ltd. export nutraceuticals internationally?
                                                </button>
                                            </h2>
                                            <div id="faq1" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Yes, we export to over 30+ countries across Asia, Africa, the Middle East, Europe, and the Americas with full regulatory compliance.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="accordion-item border-0 mb-3">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
                                                    What certifications support your export operations?
                                                </button>
                                            </h2>
                                            <div id="faq2" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Our manufacturing facilities are GMP, ISO 22000, FSSAI, and WHO-GMP certified. We also offer Halal, Vegan, and Gluten-Free certified products upon request.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="accordion-item border-0 mb-3">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
                                                    Can you provide private label or white label nutraceutical products?
                                                </button>
                                            </h2>
                                            <div id="faq3" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Absolutely. We specialize in private label exports with full branding, packaging design, and documentation support for international clients.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="accordion-item border-0 mb-3">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
                                                    What export documentation do you provide?
                                                </button>
                                            </h2>
                                            <div id="faq4" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    We offer Certificates of Origin, Health Certificates, Free Sale Certificates, Lab Test Reports, COA, and support for customs clearance.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="accordion-item border-0 mb-3">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq5">
                                                    Are your products compliant with FDA, EFSA, or NAFDAC regulations?
                                                </button>
                                            </h2>
                                            <div id="faq5" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Yes, our formulations and labeling meet guidelines set by FDA (USA), EFSA (Europe), NAFDAC (Nigeria), and other regional regulatory authorities.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="accordion-item border-0 mb-3">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq6">
                                                    How do I start importing Rexroth's nutraceutical products?
                                                </button>
                                            </h2>
                                            <div id="faq6" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Simply reach out via email at info@rexroth.com with your requirements. Our export team will assist with quotations, samples, and documentation.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default GlobalPresence; 